import { render, staticRenderFns } from "./EmbedPayment.vue?vue&type=template&id=ebbed42e&scoped=true"
import script from "./EmbedPayment.vue?vue&type=script&lang=js"
export * from "./EmbedPayment.vue?vue&type=script&lang=js"
import style0 from "./EmbedPayment.vue?vue&type=style&index=0&id=ebbed42e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebbed42e",
  null
  
)

export default component.exports